import React, { useState } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import BreadCrumbs from '../../components/BreadCrumbs';
import ControlledRowTextField from '../../components/ControlledRowTextField';
import { useForm } from 'react-hook-form';
import ButtonComponent from '../../components/ButtonComponent';
import { Form } from "reactstrap";
import { PromoCodeDta, useGeneratePromoCodeMutation } from "../../redux/services/promoCodeService";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; import { faDownload, faGear, faPrint } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";


const PromoCode = () => {
    const [promoCodeList, setPromoCodeList] = useState([])

    const [generatePromoCode, { isLoading }] = useGeneratePromoCodeMutation();

    const { control, handleSubmit, formState: { errors }, } = useForm<PromoCodeDta>({
        defaultValues: {
        },
    });

    const handleGeneratePromoCode = async (sendOBJ: any) => {
        try {

            const generatedPromoCodesResponse: any = await generatePromoCode(sendOBJ);

            if (generatedPromoCodesResponse.data.couponCode.length > 0) {
                setPromoCodeList(generatedPromoCodesResponse.data.couponCode)
            }

        } catch (error: any) {
            if (error.status === 409) {
                toast.error("You cannot create two restaurants from same name in same place");
            }
            toast.error("Failed to create restaurant. please check Enter Values");
        } finally {
        }
    }

    const onSubmit = (data: any) => {
        const obj = {
            discount: Number(data.discount),
            minTotalPrice: Number(data.minTotalPrice),
            usageLimit: Number(data.usageLimit),
            numberOfCoupons: Number(data.numberOfCoupons),
            validDays: Number(data.validDays)
        }
        handleGeneratePromoCode(obj)
    }

    const generateFileName = () => {
        const now = new Date();
        const formattedDate = now.toLocaleDateString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        const formattedTime = now.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        }).toLowerCase();
        return `PromoCodes_${formattedDate}, ${formattedTime}.txt`;
    };

    const downloadAsTextFile = () => {
        const content = promoCodeList.join('\n');
        const fileName = generateFileName();
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const printFileName = () => {
        const fileName = generateFileName();
        const content = promoCodeList;

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(`
            <html>
                <head>
                    <title>${fileName}</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                            /*background-image: url('https://curryking.s3.eu-north-1.amazonaws.com/assets/images/logo1.PNG');*/
                            background-size: cover; 
                            background-repeat: no-repeat;
                            background-position: center;
                            color: #000; 
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            background-color: rgba(255, 255, 255, 0.9);
                        }
                        th, td {
                            border: 1px solid #ccc;
                            padding: 8px;
                            text-align: left;
                        }
                        th {
                            background-color: #f4f4f4;
                        }
                    </style>
                </head>
                <body>
                    <h2>${fileName}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Promo Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${content
                    .map((code, index) => `
                                    <tr>
                                        <td>${index + 1}</td>
                                        <td>${code}</td>
                                    </tr>
                                `)
                    .join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `);
            printWindow.document.close();
            printWindow.print();
        }
    };
    //Comment

    return (
        <>
            <BreadCrumbs hasSubMenus={false} />
            <Card>
                <CardHeader className="bg-white">
                    <h5>Add New Promo Code</h5>
                    <hr />
                </CardHeader>
                <CardBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>


                        <Row className='m-2 mt-0'>
                            <Col lg="6">
                                <ControlledRowTextField
                                    label={"Discount"}
                                    inputName={"discount"}
                                    autoComplete={"off"}
                                    inputType={"number"}
                                    placeholder={"Enter Discount Type & Value"}
                                    control={control}
                                    rules={{ required: true }}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </Col>
                            <Col lg="6">
                                <ControlledRowTextField
                                    label={"Minimum Total Price"}
                                    inputName={"minTotalPrice"}
                                    autoComplete={"off"}
                                    inputType={"text"}
                                    placeholder={"Enter Minimum Total Price"}
                                    control={control}
                                    rules={{ required: true }}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </Col>
                        </Row>
                        <Row className='m-2 mt-0'>
                            <Col lg="6">
                                <ControlledRowTextField
                                    label={"Usage Limit"}
                                    inputName={"usageLimit"}
                                    autoComplete={"off"}
                                    inputType={"text"}
                                    placeholder={"Enter Usage Limit"}
                                    control={control}
                                    rules={{ required: true }}
                                    errors={errors}
                                    isRequired={true}
                                />

                            </Col>
                            <Col lg="6">
                                <ControlledRowTextField
                                    label={"Validity Days"}
                                    inputName={"validDays"}
                                    autoComplete={"off"}
                                    inputType={"text"}
                                    placeholder={"Enter Validity Days"}
                                    control={control}
                                    rules={{ required: true }}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </Col>
                        </Row>
                        <Row className='m-2 mt-0'>
                            <Col lg="6">
                                <ControlledRowTextField
                                    label={"Quantity of Codes"}
                                    inputName={"numberOfCoupons"}
                                    autoComplete={"off"}
                                    inputType={"text"}
                                    placeholder={"Enter Quantity of Codes"}
                                    control={control}
                                    rules={{ required: true }}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </Col>

                        </Row>
                        <br />
                        <Row>
                            <Col lg="9"></Col>

                            <Col lg="3">
                                <ButtonComponent titel={isLoading ? `Generating..` : `Generate`} type='submit'
                                    icon={<FontAwesomeIcon icon={faGear} spin={isLoading}
                                        title={'Generating Promo Codes'} />} fullWidth isDisabled={isLoading} />
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
            {promoCodeList.length > 0 && <Card>
                <CardBody>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">
                                    <div className='d-flex justify-content-between'>
                                        Promo Codes
                                        <div>
                                            <Button size={"sm"} onClick={downloadAsTextFile} variant="outline-success"
                                                style={{
                                                    border: '2px solid #28a745',
                                                    color: '#28a745',
                                                    backgroundColor: 'transparent'
                                                }}>
                                                <FontAwesomeIcon icon={faDownload} title={'Download Promo Codes'} />
                                            </Button>
                                            &nbsp; &nbsp;
                                            <Button size={"sm"} onClick={printFileName} variant="outline-info"
                                                style={{
                                                    border: '2px solid #b88017',
                                                    color: '#b88017',
                                                    backgroundColor: 'transparent'
                                                }}>
                                                <FontAwesomeIcon icon={faPrint} title={'Print Promo Codes'} />
                                            </Button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {promoCodeList.map((promoCode, index) => <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{promoCode}</td>
                            </tr>)}

                        </tbody>
                    </table>
                </CardBody>
            </Card>}
        </>
    )
}

export default PromoCode;